import React from "react";
import "../../styles/ContactHero.css";



function ContactHero() {
    return (
        <div className="contact-hero-container">
            <div className="content">

                <div className="contact-header-section">
                    <h1>
                        Contact Me
                    </h1>
                    <p>
                    Any question or remarks? Just write us a message!
                    </p>

                </div>
            </div>
        </div>
    );
}

export default ContactHero;
